import React, { ReactElement, useEffect, useState } from "react";
import { FormFieldType, WorkflowStep } from "../../../__generated__/api";
import { ActionProps } from "./base";
import Select from "../../select/Select";
import BooleanSelect from "../../pickers/boolean/BooleanSelect";

const TRIGGER_ACTION = "urn:fq:workflow-service-action:(urn:fq:workflow-service:system,trigger)";
const FORM_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,trigger)";
const FORM_REQUIRED_FIELD_ID = "urn:fq:workflow-service-form-field:(urn:fq:workflow-service:system,isRequired)";

function findTriggers(root: WorkflowStep, triggers: WorkflowStep[]): void {
    if (root.actionId === TRIGGER_ACTION) {
        triggers.push(root);
    }
    root.children?.forEach(child => {
        child.children?.forEach(step => findTriggers(step, triggers));
    });
}
export default function TriggerConnectorSettings(props: ActionProps): ReactElement {
    const [triggers, setTriggers] = useState<WorkflowStep[]>();

    const triggerValue = props.values.find(row => row.value.fieldId === FORM_FIELD_ID)?.value.string;
    const requiredValue = props.values.find(row => row.value.fieldId === FORM_REQUIRED_FIELD_ID)?.value.boolean;

    const [selectedTrigger, setSelectedTrigger] = useState<WorkflowStep>();
    const [isRequired, setIsRequired] = useState<boolean | undefined>();

    useEffect(() => {
        if (selectedTrigger && isRequired != null) {
            props.onChange({
                values: [
                    {
                        fieldId: FORM_FIELD_ID,
                        type: FormFieldType.Text,
                        displayValue: selectedTrigger?.name,
                        string: selectedTrigger?.id,
                    },
                    {
                        fieldId: FORM_REQUIRED_FIELD_ID,
                        type: FormFieldType.Boolean,
                        displayValue: isRequired ? "Yes" : "No",
                        boolean: isRequired,
                    },
                ],
            });
        }
    }, [selectedTrigger?.id, isRequired]);

    useEffect(() => {
        const selected = triggers?.find(trigger => trigger.id === triggerValue);
        if (selected) {
            setSelectedTrigger(selected);
        }
    }, [triggers, triggerValue]);

    useEffect(() => {
        if (requiredValue != null) {
            setIsRequired(requiredValue);
        }
    }, [requiredValue]);

    useEffect(() => {
        const triggerSteps: WorkflowStep[] = [];
        findTriggers(props.workflow, triggerSteps);
        setTriggers(triggerSteps);
    }, [props.workflow]);

    return (
        <div className="">
            <div>
                <div className="">
                    Trigger Group
                </div>

                <div className="">
                    <Select
                        minRequired={1}
                        onChange={value => {
                            setSelectedTrigger(value.data);
                        }}
                        value={!selectedTrigger ? undefined : {
                            label: selectedTrigger.name,
                            value: selectedTrigger.id,
                            data: selectedTrigger,
                        }}
                        options={triggers?.map(trigger => ({
                            label: trigger.name,
                            value: trigger.id,
                            data: trigger,
                        })) ?? []}
                    />
                </div>
                <small>
                    Select the trigger group. When ever trigger connector in this trigger group executes,
                    then the trigger will also execute.
                </small>
            </div>
            <div>
                <div className="mt-3">
                    Is the task required
                </div>

                <div className="">
                    <BooleanSelect
                        value={isRequired}
                        isRequired
                        onChange={value => setIsRequired(value as boolean)}
                    />
                </div>
                <small>
                    Is this connector required for the task to execute? If you select yes, the associated
                    trigger will not fire if this connector does not fire. If you select No, the trigger may
                    execute with or without this task.
                </small>
            </div>

        </div>

    );
}
